<div class="col-lg-12 filter-section p-0">
  
  <kn-br-facet-list
    [isDialog]="hasTrigger"
    (closeList)="close()"
    [class.active]="isActive$ | async"
    [class.dialog]="hasTrigger"
  ></kn-br-facet-list>
</div>
